// ============================================================
// ÇAMLICA ÇALIŞTAY — TEK KAYNAK VERİ DOSYASI
// ============================================================
// Bu dosyada tanımlanan tüm veriler ve metinler sitede şu
// sayfalarda / bileşenlerde kullanılmaktadır:
//
//   SITE_CONFIG         → Navbar, Footer, Countdown, ContactPage, tüm meta
//   NAV_LINKS           → Navbar (navigasyon linkleri)
//   NAVBAR_CTA          → Navbar ("Hemen Başvur" butonu)
//   HERO_CONTENT        → HomePage (hero başlık, açıklama, butonlar, istatistikler)
//   WHY_JOIN_SECTION    → HomePage ("Neden Katılmalısın?" bölüm başlıkları)
//   WHY_JOIN            → HomePage ("Neden Katılmalısın?" kartları)
//   HOME_COMMITTEES     → HomePage (komiteler önizleme başlık/buton)
//   HOME_CTA            → HomePage (sayfa sonu CTA bandı)
//   ABOUT_PAGE          → AboutPage (tüm metin, misyon, vizyon, değerler, timeline, CTA)
//   COMMITTEES_PAGE     → CommitteesPage (hero metni, filtre etiketleri)
//   COMMITTEES          → CommitteesPage (grid), CommitteeDetailPage (detay),
//                         HomePage (ilk 4 komite önizleme)
//   TEAM_MEMBERS        → TeamPage (organizasyon şeması - tier 1/2)
//   CONTACT_PAGE        → ContactPage (başlık, açıklama, etiketler, SSS)
//   SPONSORS_PAGE       → SponsorsPage (hero, tier başlıkları, sponsor listesi, CTA)
//   FOOTER_CONTENT      → Footer (açıklama, link başlıkları, telif)
// ============================================================

// ── Genel Site Yapılandırması ──────────────────────────────
// Kullanım: Navbar logosu, Footer, Countdown bileşeni, ContactPage iletişim kartları
export const SITE_CONFIG = {
  name: "Çamlıca Çalıştay",
  shortName: "ÇÇ",
  tagline: "Hukukun Geleceğini Tartışıyoruz",
  edition: "2. Dönem",
  year: "2026",
  eventDate: new Date("2026-05-02T09:00:00"),  // Countdown + hero location
  location: "İatanbul Medipol Üniversitesi Kavacık Güney Kampüsü, İstanbul",
  email: "camlicacalistay@gmail.com",        // ContactPage e-posta kartı
  phone: "+90 532 392 45 70",                   // ContactPage telefon kartı
  instagram: "https://www.instagram.com/camlicalistay?igsh=bTN0amE2d3RtdmQ5",
  googleFormUrl: "https://docs.google.com/forms/d/e/1FAIpQLSdOmGlDldZSWbl5Y7FUMCICRwnbZ0zW5pWetts-5ca3xhQMYA/viewform?usp=publish-editor",
  googleFormUrl2: "https://docs.google.com/forms/d/e/1FAIpQLSc01hbQVlVeLepqmH-MFRd1diic-I8UrPnPaoXuQufD9cW26A/viewform?usp=publish-editor",
  googleFormUrl3: "https://docs.google.com/forms/d/e/1FAIpQLSdcgdYTeI8kF0JzvIMZc_NfTRxduJpGZBXliHgZ94EEzbkrMg/viewform?usp=publish-editor",
  // ApplicationPage → "Başvuru için Google Formu kullanılır" butonu linki
};

// ── Navbar Navigasyon Linkleri ─────────────────────────────
// Kullanım: Navbar.jsx masaüstü linkleri + mobil menü
export const NAV_LINKS = [
  { label: "Ana Sayfa",  path: "/" },
  { label: "Hakkımızda", path: "/hakkimizda" },
  { label: "Komiteler",  path: "/komiteler" },
  { label: "Ekibimiz",   path: "/ekibimiz" },
  { label: "Sponsorlar", path: "/sponsorlar" },
  { label: "İletişim",   path: "/iletisim" },
];

// ── Navbar CTA Butonu ──────────────────────────────────────
// Kullanım: Navbar.jsx sağ üst köşe butonu
export const NAVBAR_CTA = {
  label: "Hemen Başvur",
  path:  "/basvuru",
};

// ── Ana Sayfa — Hero Bölümü ────────────────────────────────
// Kullanım: HomePage.jsx → <section className="hero">
export const HERO_CONTENT = {
  editionBadge:    "2. Dönem · 2026",
  titleLine1:      "Hukukun",
  titleLine2Italic:"Geleceğini",
  titleLine2Rest:  " Tartışıyoruz",
  description:
    "Çamlıca Çalıştay, hukuk alanındaki kritik meseleleri akademik titizlikle ele alan, lise öğrencilerini bir araya getiren prestijli fikir ve tartışma platformu.",
  primaryBtn:  "Başvurunu Yap",
  secondaryBtn:"Komiteleri Keşfet",
  scrollLabel: "Aşağı Kaydır",
  stats: [
    { number: "8",    label: "Komite"  },
    { number: "160+", label: "Delege"  },
    { number: "2.",   label: "Dönem"   },
  ],
};

// ── Ana Sayfa — "Neden Katılmalısın?" Bölüm Başlıkları ────
// Kullanım: HomePage.jsx → <section className="why-section">
export const WHY_JOIN_SECTION = {
  tag:         "Neden Katılmalısın?",
  title:       "Çalıştay Sana Ne Kazandırır?",
  description: "Tek bir hafta sonu, düşünce biçimini ve kariyer yolunu değiştirebilir.",
};

// ── Ana Sayfa — "Neden Katılmalısın?" Kartları ─────────────
// Kullanım: HomePage.jsx → WHY_JOIN.map(...)
export const WHY_JOIN = [
  { icon: "🧠", title: "Hukuki Düşünce",  desc: "Lise öğrencisi moderatörler eşliğinde gerçek hukuki tartışma deneyimi yaşayın." },
  { icon: "🤝", title: "Güçlü Ağ",        desc: "İstanbul'un farklı liselerinden seçilmiş öğrencilerle tanışın, ağınızı genişletin." },
  { icon: "✍️", title: "Pratik Beceri",    desc: "Araştırma, yazma, konuşma ve müzakere becerilerinizi gerçek ortamda geliştirin." },
  { icon: "📜", title: "Sertifika",        desc: "Katılım sertifikası ve üstün performans ödülleri ile kendinizi belgeleyin." },
  { icon: "⚖️", title: "Hukuk Kültürü",   desc: "Ulusal ve uluslararası hukuk meselelerini derinlemesine analiz edin." },
  { icon: "🏆", title: "Tanınma",          desc: "En iyi delege ödülleri ve komite mükemmellik sertifikaları ile öne çıkın." },
];

// ── Ana Sayfa — Komiteler Önizleme Bölümü ─────────────────
// Kullanım: HomePage.jsx → <section className="committees-preview">
export const HOME_COMMITTEES = {
  tag:        "Komiteler",
  title:      "Bu Yılki Komiteler",
  viewAllBtn: "Tümünü Gör",
};

// ── Ana Sayfa — CTA Bandı ──────────────────────────────────
// Kullanım: HomePage.jsx → <section className="cta-banner">
export const HOME_CTA = {
  title:       "Hazır mısın?",
  description: "Kontenjanlar dolmadan yerinizi ayırtın. Başvurular sınırlı kontenjanla açıktır.",
  btnLabel:    "Şimdi Başvur",
};

// ── Hakkımızda Sayfası — Tüm Metin ve Veriler ─────────────
// Kullanım: AboutPage.jsx (tüm bölümler)
export const ABOUT_PAGE = {
  // Hero bölümü — AboutPage.jsx → <section className="page-hero">
  hero: {
    tag:         "Hakkımızda",
    title:       "Biz Kimiz?",
    description: "Çamlıca Çalıştay, 2026 yılında Çamlıca Kız Anadolu İmam Hatip Lisesi öğrencilerinin girişimiyle hayata geçirildi. Hukuki tartışma kültürünü lise düzeyine taşıma vizyonuyla kuruldu.",
  },
  // Misyon kartı — AboutPage.jsx → .mission-card (sol)
  mission: {
    icon:  "🎯",
    title: "Misyonumuz",
    text:  "Hukuk alanındaki güncel sorunları tartışmaya açarak bilgi paylaşımını teşvik etmeyi, akademik ve pratik çözümler üretmeyi ve yapıcı bir tartışma ortamı oluşturmayı amaçlıyoruz. Bu doğrultuda hukuk bilincini artırmayı, hukukun üstünlüğünü savunmayı ve toplumsal farkındalık oluşturmayı hedefliyor",
  },
  // Vizyon kartı — AboutPage.jsx → .mission-card (sağ)
  vision: {
    icon:  "🌟",
    title: "Vizyonumuz",
    text:  "Çamlıca Çalıştay '26, olayların özünü kavrayabilen, sorunları teşhis edebilen, kişisel haklarını çok iyi bilen, iletişim becerileri güçlü olan bireyler yetiştirmeyi hedefleyerek akademik anlamda katkı sağlar.",
  },
  // Değerler bölümü — AboutPage.jsx → <section className="values-section">
  valuesSectionTag:   "Değerlerimiz",
  valuesSectionTitle: "Ne Üzerine İnşa Edildik?",
  values: [
    { icon: "🔍", title: "Eleştirel Düşünce", desc: "Her hukuki meseleyi çok boyutlu ele alır, varsayımları sorgulayanları destekleriz." },
    { icon: "🕊️", title: "Yapıcı Diyalog",   desc: "Farklı hukuki görüşlerin saygı çerçevesinde tartışılması kültürünü benimseriz." },
    { icon: "📚", title: "Akademik Titizlik", desc: "Kanıta dayalı argümanlar ve hukuki metodolojiye bağlılık temelimizdir." },
    { icon: "🌱", title: "Kapsayıcılık",      desc: "Her liseden, bölgeden ve geçmişten öğrenciye kapılarımız açık." },
  ],
  // Tarihçe bölümü — AboutPage.jsx → <section className="timeline-section">
  timelineSectionTag:   "Tarihçe",
  timelineSectionTitle: "Büyüme Hikayemiz",
  timeline: [
    { year: "2024", title: "1. Dönem", desc: "7 komite ve 140+ delegenin katılımıyla, Medeniyet Üniversitesi’nde ilk çalıştayımızı başarıyla gerçekleştirdik." },
    { year: "2026", title: "2. Dönem", desc: "8 komite ve 160+ delege hedefiyle planlanan ikinci çalıştayımız başlıyor." },
  ],
  // CTA bölümü — AboutPage.jsx → <section className="about-cta">
  ctaTitle:       "Sen de Bu Hikayenin Parçası Ol",
  ctaDescription: "Çalıştayımız için başvurular açık. Yerinizi hemen ayırtın.",
  ctaBtnLabel:    "Başvuru Formuna Git",
};

// ── Komiteler Sayfası — Hero ve Filtre ─────────────────────
// Kullanım: CommitteesPage.jsx → hero + filtre butonları
export const COMMITTEES_PAGE = {
  hero: {
    tag:         "Komiteler",
    title:       "Bu Yılki Komiteler",
    description: "8 farklı hukuk alanında hazırlanmış komiteler sizi bekliyor. Her komitede iki lise öğrencisi moderatör tartışmaları yönetmektedir.",
  },
  filterLabel:   "Seviyeye Göre Filtrele:",
  difficulties:  ["Tümü", "Başlangıç", "Orta", "İleri"],
};

// ── Komiteler — Tüm Komite Verileri ───────────────────────
// Kullanım: CommitteesPage.jsx (grid), CommitteeDetailPage.jsx (detay sayfası),
//           HomePage.jsx (ilk 4 komite önizleme)
export const COMMITTEES = [
  {
    id: "yapay-zeka-hukuku",
    slug: "yapay-zeka-hukuku",
    title: "Yapay Zeka Hukuku",
    subtitle: "Teknoloji, Sorumluluk ve Etik",
    icon: "🤖",
    color: "#e85d2f",
    description: "Yapay zekanın hukuki statüsünü, algoritmik karar süreçlerinin sorumluluğunu ve dijital çağda kişilik haklarını tartışıyoruz.",
    topics: [
      "Yapay Zekanın Hukukta Kullanımı",
      "Yapay Zekanın Hukuki Sorumluluğu",
    ],
    guideFile: "/docs/yapay-zeka-hukuku-rehber.pdf",
    moderators: [
      { name: "Eymen Taha Midilli", title: "Komite Moderatörü", bio: "10. sınıf öğrencisi. Teknoloji hukuku ve dijital haklar alanında araştırmalar yapıyor.", photo: null },
      { name: "Zülal Limanov",      title: "Komite Moderatörü", bio: "11. sınıf öğrencisi. Yapay zeka etiği ve bilişim hukuku üzerine çalışıyor.", photo: null },
    ],
    delegate_count: 20,
    difficulty: "Orta",
  },
  {
    id: "toplumsal-cinsiyet-hukuku",
    slug: "toplumsal-cinsiyet-hukuku",
    title: "Toplumsal Cinsiyet ve Hukuk",
    subtitle: "Eşitlik, Hak ve Politika",
    icon: "⚢",
    color: "#e85d2f",
    description: "Toplumsal cinsiyet eşitliğinin hukuki boyutlarını, ayrımcılık karşıtı düzenlemeleri ve feminist hukuk teorisini tartışıyoruz.",
    topics: [
      "Kişinin Beden Dokunulmazlığına Karşı Suçlarda Rıza Kavramı: Rızanın Geri Alınabilirliği, Delil Sorunları ve İspat Yükü",
      "Süresiz Nafaka Tartışmaları Boşanma Sonrası Ekonomik Eşitsizlik ve Erkek Mağduriyeti İddiaları",
      "6284 Sayılı Kanun Çerçevesinde İstanbul Sözleşmesi’nin Gerekliliğinin Değerlendirilmesi",
      "İş Yerinde Eşit Ücret İlkesi ve “Cam Tavan” Sorunu",
      "Kimlik ve Yönelim Temelli Ayrımcılık Yasağı, Sapkın Akımlar  ve Nefret Suçlarının Hukuki Düzenlenmesi",
    ],
    guideFile: "/docs/cinsiyet-hukuku-rehber.pdf",
    moderators: [
      { name: "Beyza Nur Esen", title: "Komite Moderatörü", bio: "10. sınıf öğrencisi. Feminist hukuk teorisi ve kadın hakları alanında araştırmalar yapıyor.", photo: null },
      { name: "Eymen Öksüz",    title: "Komite Moderatörü", bio: "11. sınıf öğrencisi. Ayrımcılık karşıtı hukuk ve sosyal politikalar üzerine araştırma yapıyor.", photo: null },
    ],
    delegate_count: 20,
    difficulty: "Orta",
  },
  {
    id: "devlet-kamu-hukuku",
    slug: "devlet-kamu-hukuku",
    title: "Devlet ve Kamu Hukuku",
    subtitle: "Anayasal Düzen ve Yönetim",
    icon: "🏛️",
    color: "#c0392b",
    description: "Anayasal hakların sınırlarını, yargı bağımsızlığını ve demokratik hukuk devleti ilkelerini akademik perspektifle ele alıyoruz.",
    topics: [
      "Olağanüstü Hâl Rejimleri",
      "Uluslararası Mahkemelerin Ulusal Yargıyı Bağlayıcılığı",
      "Kayyum Atamalarının Yerel Demokrasi Üzerindeki Etkileri",
      "Cumhurbaşkanlığı Hükümet Sisteminin Güçler Ayrılığı İlkesine Etkisi",
      "Nefret Söylemi ve İfade Özgürlüğü",
      "Anayasanın Değiştirilemez Maddelerinin Demokratik Meşruiyeti",
    ],
    guideFile: "/docs/kamu-hukuku-rehber.pdf",
    moderators: [
      { name: "Bilge Zehra Teke", title: "Komite Moderatörü", bio: "10. sınıf öğrencisi. Anayasa hukuku ve insan hakları alanına ilgi duymaktadır.", photo: null },
      { name: "Rim Bayraktar",    title: "Komite Moderatörü", bio: "10. sınıf öğrencisi. Kamu hukuku tartışmalarında deneyimli bir müzakereci.", photo: null },
    ],
    delegate_count: 20,
    difficulty: "İleri",
  },
  {
    id: "global-politics",
    slug: "global-politics",
    title: "Global Politics",
    subtitle: "Uluslararası Düzen ve Güç",
    icon: "🌍",
    color: "#d35400",
    description: "Değişen küresel güç dengelerini, çok taraflı diplomasi krizlerini ve uluslararası hukuki düzenin geleceğini tartışıyoruz.",
    topics: [
      "Vietnam War",
      "Berlin Wall",
      "The Legitimacy of U.S. Abortion Law",
      "Küresel İklim Sözleşmeleri ve Uygulama",
    ],
    guideFile: "/docs/global-politics-rehber.pdf",
    moderators: [
      { name: "Elif Özyurt",   title: "Komite Moderatörü", bio: "10. sınıf öğrencisi. Uluslararası ilişkiler ve diplomasi tarihi üzerine araştırmalar yapıyor.", photo: null },
      { name: "Beyza Tüfekçi", title: "Komite Moderatörü", bio: "10. sınıf öğrencisi. Küresel güvenlik ve çatışma analizi alanında çalışıyor.", photo: null },
    ],
    delegate_count: 20,
    difficulty: "Orta",
  },
  {
    id: "saglik-hukuku",
    slug: "saglik-hukuku",
    title: "Sağlık Hukuku",
    subtitle: "Biyoetik ve Hasta Hakları",
    icon: "🏥",
    color: "#c0392b",
    description: "Sağlık hizmetlerine erişim hakkını, biyoetik ikilemleri ve tıbbi sorumluluk hukukunu derinlemesine inceliyoruz.",
    topics: [
      "Sağlık Çalışanlarına Yönelik Şiddet: Beyaz Kod Uygulaması ve Cezai Yaptırımların Etkinliği",
      " İlaç Hukuku: Ruhsatsız İlaçların Temini ve SGK Rücu Davaları",
      "Yapay Zeka Destekli Tanı Sistemlerinde Hukuki Sorumluluk ve Teletıp Mevzuatı",
      "Tıbbi Malpraktis Davalarında Rücu Mekanizması ve Güncel Yargıtay Kararları",
      "Sağlık Verilerinin Gizliliği ve Dijital Sistemler",
      "Organ Bağışı ve Nakil Hukuku",
      "Estetik Cerrahide Hukuki Sorumluluk",
    ],
    guideFile: "/docs/saglik-hukuku-rehber.pdf",
    moderators: [
      { name: "Emine Zehra Yiğit", title: "Komite Moderatörü", bio: "11. sınıf öğrencisi. Biyoetik ve tıp hukuku alanında derin ilgiye sahip.", photo: null },
      { name: "Yasir Şengül",      title: "Komite Moderatörü", bio: "10. sınıf öğrencisi. Hasta hakları ve sağlık politikaları üzerine araştırmalar yapıyor.", photo: null },
    ],
    delegate_count: 20,
    difficulty: "Başlangıç",
  },
  {
    id: "uluslararasi-ceza-hukuku",
    slug: "uluslararasi-ceza-hukuku",
    title: "Uluslararası Ceza Hukuku",
    subtitle: "Hesap Verebilirlik ve Adalet",
    icon: "⚖️",
    color: "#922b21",
    description: "Uluslararası Ceza Mahkemesi'nin rolünü, savaş suçları kovuşturmalarını ve adalet ile barış arasındaki gerilimi tartışıyoruz.",
    topics: [
      "Ekokırımın Roma Statüsü’ne beşinci temel suç kategorisi olarak dahil edilmesi ve uygulanabilirliği",
      "Devlet başkanlarının mutlak dokunulmazlığının uluslararası ceza yargılamaları önündeki hukuki engelleri",
      "BM Güvenlik Konseyi’nin veto yetkisinin UCM’nin yargı yetkisi üzerindeki kısıtlayıcı rolü",
      "Kültürel ve dini mirasın kasıtlı imhasının insanlığa karşı suçlar başlığında incelenmesi",
      "UCM tutuklama emirlerinin üye devletler tarafından uygulanmaması sorunu ve yaptırım mekanizmalar",
      "Mağdur Güven Fonu aracılığıyla onarıcı adalet ve tazminat süreçlerinin etkinleştirilmesi",
    ],
    guideFile: "/docs/uluslararasi-ceza-rehber.pdf",
    moderators: [
      { name: "Melek Şamat",        title: "Komite Moderatörü", bio: "11. sınıf öğrencisi. UCM ve insancıl hukuk alanında araştırmalar yapıyor.", photo: null },
      { name: "Selman Emre Şamat",  title: "Komite Moderatörü", bio: "11. sınıf öğrencisi. Uluslararası ceza yargılamaları üzerine çalışıyor.", photo: null },
    ],
    delegate_count: 20,
    difficulty: "İleri",
  },
  {
    id: "catisma-hukuku",
    slug: "catisma-hukuku",
    title: "Çatışma Hukuku",
    subtitle: "Silahlı Çatışma ve İnsancıl Hukuk",
    icon: "🕊️",
    color: "#d35400",
    description: "Silahlı çatışmaları düzenleyen uluslararası insancıl hukuku, mülteci haklarını ve barış inşasını ele alıyoruz.",
    topics: [
      "Silahlı Çatışmalarda Sivillerin Korunması ve Uluslararası Hukukun Uygulanması",
      "Savaş Suçları ve Uluslararası Ceza Sorumluluğu",
      "Çocukların Silahlı Çatışmalarda Kullanılması ve Korunmasına Yönelik Uluslararası Hukuki Çerçeve",
      "Çocukların Silahlı Çatışmalarda Kullanılması ve Korunmasına Yönelik Uluslararası Hukuki Çerçeve",
      "Silahlı Çatışmalarda Cinsel Şiddet Suçları ve Uluslararası Hukukta Hesap Verebilirlik",
      " Silahlı Çatışmaların Yol Açtığı Mülteci ve Zorunlu Yerinden Edilme Krizleri",
      "Yeni Nesil Çatışma Biçimleri ve Uluslararası Hukuktaki Düzenleme Boşlukları",
      "Savaş Esirlerinin ve Gözaltındaki Kişilerin Statüsü",
    ],
    guideFile: "/docs/catisma-hukuku-rehber.pdf",
    moderators: [
      { name: "Hanne Meryem Aldı", title: "Komite Moderatörü", bio: "10. sınıf öğrencisi. İnsancıl hukuk ve mülteci hakları alanında aktif araştırmacı.", photo: null },
      { name: "Ahme Akif Atlı",    title: "Komite Moderatörü", bio: "10. sınıf öğrencisi. Uluslararası çatışma analizi ve barış müzakereleri üzerine çalışıyor.", photo: null },
    ],
    delegate_count: 20,
    difficulty: "Orta",
  },
  {
    id: "kriminoloji",
    slug: "kriminoloji",
    title: "Kriminoloji",
    subtitle: "Suç, Toplum ve Ceza",
    icon: "🔎",
    color: "#922b21",
    description: "Suçun toplumsal köklerini, cezalandırma ile rehabilitasyon tartışmasını ve suç önleme politikalarını inceliyoruz.",
    topics: [
      "İdam cezasının gerekliliği ve uygulanabilirliği",
      "Ceza adalet sisteminde öncelik rehabilitasyon mu yoksa cezalandırma mı olmalıdır?",
      "Erişkin olmayan bireylerin suça sürüklenme durumu",
      "Suçun kökeni biyolojik midir yoksa toplumsal mıdır?",
      "Sistem adaleti sağlayamazsa bireylerin kendi adaletini sağlaması kabul edilebilir mi?",
      "Cezaların caydırıcılığının suç oranları üzerindeki etkisi",
      "Medyanın suçu ve suçluyu özendirici biçimde yansıtmasının etkileri",
      "Suça sürüklenmek, suçu işlemeyi meşrulaştırır mı?",
      "Cezai uygulamalarda suçun arka planı ve suçlunun geçmiş deneyimlerinin etkisi",
    ],
    guideFile: "/docs/kriminoloji-rehber.pdf",
    moderators: [
      { name: "Elif Rana Durdu",     title: "Komite Moderatörü", bio: "12. sınıf öğrencisi. Kriminoloji ve ceza adaleti reformu üzerine araştırmalar yapıyor.", photo: null },
      { name: "Elif Sude Aslans",    title: "Komite Moderatörü", bio: "11. sınıf öğrencisi. Suç psikolojisi ve sosyal politika alanlarına ilgi duyuyor.", photo: null },
    ],
    delegate_count: 20,
    difficulty: "Başlangıç",
  },
 
];

// ── Ekip Üyeleri ───────────────────────────────────────────
// Kullanım: TeamPage.jsx (organizasyon şeması)
// tier 1 = Yönetim Kurulu, tier 2 = Direktörler,
export const TEAM_MEMBERS = [
  { id: 1, name: "Bengisu Erkoç",       role: "Genel Koordinatör",    department: "Yönetim",   bio: "10. sınıf öğrencisi. Çamlıca Çalıştay'ın kurucu genel koordinatörü.", linkedin: "https://www.instagram.com/bengisuerkc/", photo: null, tier: 1 },
  { id: 2, name: "Vildan Leyla Çalık",    role: "Akademi Eş Başkanı",       department: "a",   bio: "11. sınıf öğrencisi. Komite başkanlarını belirler ve komite konularını kontrol eder.", linkedin: "https://www.instagram.com/vildanleylacalik/", photo: null, tier: 2 },
  { id: 3, name: "Nilgün Nihal Çalık",   role: "Akademi Eş Başkanı",    department: "a",  bio: "11. sınıf öğrencisi. Komiteleri oluşturur ve study guide içeriklerini kontrol eder. ", linkedin: "https://www.instagram.com/nilgunnihalcalik/", photo: null, tier: 2 },
  { id: 4, name: "Betül Aydın",   role: "PR Eş Başkanı",  department: "a",    bio: "10. sınıf öğrencisi. Tanıtım, sosyal medya ve dış iletişim süreçlerini yönetir..", linkedin: "https://www.instagram.com/beettuullllll/", photo: null, tier: 2 },
  { id: 5, name: "Sofya Pryhorova",         role: "PR Eş Başkanı",   department: "a",  bio: "11. sınıf öğrencisi. Etkinliğin görünürlüğünü artırmak için içerik üretimi ve paylaşımlarla ilgilenir.", linkedin: "https://www.instagram.com/50f1k/", photo: null, tier: 2 },
  { id: 6, name: "İsra Nur Asya Ketencek",     role: "Lojistik Başkanı",department: "a",  bio: "11. sınıf öğrencisi. Etkinlik süresince salon, ulaşım, ekipman ve tüm operasyonel süreçlerin sorunsuz ilerlemesini sağlar.", linkedin: "https://www.instagram.com/isranurasyaketenci/", photo: null, tier: 2 },
  { id: 7, name: "Burcu Dallı",       role: "Finans Eş Başkanı",      department: "a",  bio: "10. sınıf öğrencisi. Sponsor bulma süreçlerini yürütür ve gelen mailleri kontrol eder.", linkedin: "https://www.instagram.com/burcu_.dll/", photo: null, tier: 2 },
  { id: 8, name: "Meryem Ayıker",          role: "Finans Eş Başkanı",  department: "a",  bio: "10. sınıf öğrencisi. Bütçeyi planlar ve gelir-gider dengesini kontrol eder.", linkedin: "https://www.instagram.com/meryemayiker/", photo: null, tier: 2 },
  { id: 9, name: "Hüsna Ecrin Aktaş",         role: "IT Başkanı",       department: "a",    bio: "10. sınıf öğrencisi. Tüm görsel materyallerin tasarımından sorumludur.", linkedin: "www.instagram.com", photo: null, tier: 2 },
  { id: 7, name: "Ela Sezer",       role: "IT Eş Başkanı",      department: "a",  bio: "10. sınıf öğrencisi. Tüm görsel materyallerin tasarımından sorumludur.", linkedin: "https://www.instagram.com/elas.s11?igsh=Z2wyeHdzNjhndTl5", photo: null, tier: 2 },
  { id: 8, name: "Şeyma Melek",          role: "Press Başkanı",  department: "a",  bio: "10. sınıf öğrencisi. Etkinlik süresince fotoğraf ve video çekimlerini gerçekleştirir.", linkedin: "https://www.instagram.com/m923id?igsh=dzRmN2d3ajV4MW1i", photo: null, tier: 2 },
  { id: 9, name: "Beyza Nur Esen",         role: "Web Sitesi Kurucusu",       department: "a",    bio: "10. sınıf öğrencisi. Web sitesini etkinliğe göre düzenler ve günceller.", linkedin: "https://www.instagram.com/beyzaa.een/", photo: null, tier: 2 },
  { id: 9, name: "Eymen Taha Midilli",         role: "Web Sitesi Kurucusu",       department: "a",    bio: "10. sınıf öğrencisi. Web sitesinin temel kodlarını yazar ve çalışır hâle getirir.", linkedin: "https://www.instagram.com/eymentahamidilli/", photo: null, tier: 2 },
    { id: 9, name: "Saliha Meryem Çay",         role: "Organizasyon Başkanı",       department: "a",    bio: "10. sınıf öğrencisi. Organizasyon işleri ile ilgilenir.", linkedin: "https://www.instagram.com/meryemcayy?igsh=czVsOHNpbXhmeWlj", photo: null, tier: 2 },
];

// ── İletişim Sayfası İçeriği ───────────────────────────────
// Kullanım: ContactPage.jsx (tüm bölümler)
export const CONTACT_PAGE = {
  // Hero bölümü — <section className="page-hero">
  hero: {
    tag:         "İletişim",
    title:       "Bizimle İletişime Geçin",
    description: "Sorularınız için bize ulaşın. En kısa sürede geri dönüş sağlıyoruz.",
  },
  // Sol panel başlık ve açıklama
  sectionTitle:       "Bize Ulaşın",
  sectionDescription: "Başvuru süreci, komiteler veya organizasyon hakkındaki tüm sorularınız için iletişim kanallarımızı kullanabilirsiniz.",
  // İletişim kartı etiket metinleri
  labels: {
    email:       "E-posta",
    phone:       "Telefon",
    address:     "Adres",
    responseTime:"Yanıt Süresi",
    responseVal: "1–2 iş günü",
  },
  // SSS accordion — CommitteesPage altında
  faqTitle: "Sık Sorulan Sorular",
  faq: [
    { q: "Başvuru ücreti var mı?",       a: "Çamlıca Çalıştay'a katılım ücretlidir. Başvuru ücretimiz delegeler için açmış olduğumuz form içinde belirtilmiştir." },
    { q: "Hangi okullardan başvurabilir?",a: "İstanbul'daki tüm liselerden 9, 10, 11 ve 12. sınıf öğrencileri başvurabilir." },
    { q: "Dil gereksinimi var mı?",       a: "7 tane kömitemiz Türkçe yürütülmektedir. Global Politics komitesi İngilizce olarak yürütülecektir." },
    { q: "Sonuçlar ne zaman açıklanır?",  a: "Başvuru kapandıktan sonra 5 iş günü içinde e-posta ile bilgilendirileceksiniz." },
  ],
};

// ── Sponsorlar Sayfası İçeriği ─────────────────────────────
// Kullanım: SponsorsPage.jsx (tüm bölümler)
export const SPONSORS_PAGE = {
  // Hero bölümü
  hero: {
    tag:         "Sponsorlar",
    title:       "Destekçilerimiz",
    description: "Çamlıca Çalıştay'ı mümkün kılan değerli kurum ve kuruluşlara teşekkür ederiz. Onların desteğiyle lise öğrencileri için kaliteli bir tartışma platformu oluşturuyoruz.",
  },
  // Sponsor kademe başlıkları
  tiers: {
    Ana: "Ana Sponsorlar",
    Bronz:     " Bronz Sponsorlar",
    Ürün:   "Ürün Sponsorlar",
  },
  // Sponsor iş birliği CTA bölümü
  partnerTitle:       "Sponsor Olmak İster misiniz?",
  partnerDescription: "Kurumunuzu genç hukuk meraklılarıyla buluşturmak ve Çamlıca Çalıştay'ı desteklemek için bizimle iletişime geçin.",
  partnerBtn:         "Sponsor Paketi İçin İletişime Geçin",
  // Sponsor listesi — logoUrl: null olursa isim baş harflerinden avatar üretilir
  sponsors: [
    { id: 1, name: "Ahmet Erkoç", tier: "Ana", logoUrl: null, website: "#", description: "Eğitimde yenilikçi projeleri destekleyen İş Adamı ve Girişimci." },
    { id: 2, name: "Ensar Vakfı",       tier: "Bronz", logoUrl: null, website: "#", description: "insani değerlere bağlı bir nesil yetiştirmek amacıyla, nitelikli akademik çalışma ve sürekli proje geliştiren ve hizmete sunan bir vakıftır." },
    { id: 3, name: "ÜSİMDER",       tier: "Bronz",     logoUrl: null, website: "#", description: " Üsküdar İmam Hatip Lisesi Mezunları ve Mensupları Derneği." },
    { id: 4, name: "Tatlıköy",         tier: "Ürün",     logoUrl: null, website: "#", description: "Tatlıköy, etkinliğimizin ana ürün sponsoru olarak aralardaki ikramlarımızı lezzetli hale getiriyor." },
    { id: 5, name: "The Game",  tier: "Ürün",   logoUrl: null, website: "#", description: "Dijital etkinlik ve oyun merkezi olan The Game, etkinliğimizde ürün sponsoru olarak bizlere destek olmaktadır." },
  ],
};

// ── Footer İçeriği ─────────────────────────────────────────
// Kullanım: Footer.jsx (tüm alt bilgi bölümleri)
export const FOOTER_CONTENT = {
  description:     "Hukuki tartışma kültürünü lise öğrencilerine kazandırmak, eleştirel düşünceyi ve demokratik söylemi güçlendirmek için buradayız.",
  quickLinksTitle: "Hızlı Linkler",
  contactTitle:    "İletişim",
  copyright:       "Çamlıca Çalıştay. Tüm hakları saklıdır.",
  privacyLabel:    "Gizlilik Politikası",
  termsLabel:      "Kullanım Koşulları",
};
